/* SLIDE 23 */
/* SLIDE 24 */
/* SLIDE 25 */

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonBot from "shared/components/ButtonBot";
import AppCheckBox from "shared/components/AppCheckBox";
import discountIcon from "assets/icons/discountIcon.svg";
import plusIcon from "assets/icons/plusIcon.svg";
import { createParking, updateParking, getParkingById } from "features/parking/usecases/ParkingUsecases";

const ParkingFormAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Check if this is an edit (data passed from previous page)
  const isEdit = location.state && location.state.parkingData;

  const [formData, setFormData] = useState({
    parkingId: "",
    parkingName: "",
    parkingSpaces: "",
    classCd: "010",
    creationDate: "",
    editDate: "",
    timeRanges: {},
    discountList: {},
  });

  const [operationTimes, setOperationTimes] = useState({
    regular: true,
    halfDay: false,
    standby: false,
    publicHoliday: false,
  });

  const [timeRanges, setTimeRanges] = useState({
    regularStart: "",
    regularEnd: "",
    halfDayStart: "",
    halfDayEnd: "",
    publicHolidayStart: "",
    publicHolidayEnd: "",
  });

  const [showPopup, setShowPopup] = useState(false);
  const [discountItems, setDiscountItems] = useState([
    { id: 1, icon: "Icon", title: "20분권", price: "500원", selected: false },
    { id: 2, icon: "Icon", title: "1시간권", price: "1,000원", selected: false },
    { id: 3, icon: "Icon", title: "3시간권", price: "2,500원", selected: false },
  ]);

  const [newDiscount, setNewDiscount] = useState({
    name: "",
    amount: "0원",
  });

  useEffect(() => {
    const fetchParkingData = async () => {
      if (isEdit) {
        try {
          const response = await getParkingById(location.state.parkingId);
          const parkingData = response.data;
  
          setFormData({
            parkingId: parkingData.parkingId,
            parkingName: parkingData.parkingName,
            parkingSpaces: parkingData.parkingSpaces,
            classCd: parkingData.classCd,
            creationDate: parkingData.creationDate,
            editDate: parkingData.editDate,
          });

          setTimeRanges({
            regularStart: parkingData.regularStart,
            regularEnd: parkingData.regularEnd,
            halfDayStart: parkingData.halfDayEnd,
            publicHolidayStart: parkingData.publicHolidayStart,
            publicHolidayEnd: parkingData.publicHolidayEnd,
          })

          setDiscountItems(
            parkingData.discountList?.map((item, index) => ({
              id: index + 1,
              icon: "Icon",
              title: item.title,
              price: item.price,
              selected: false,
            })) || []
          );
        } catch (error) {
          console.error("", error);
        }
      }
    };
  
    fetchParkingData();
  }, []);

  const handleOpenPopup = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleApply = () => {
    if (newDiscount.name && newDiscount.amount) {
      // Create new discount item
      const newItem = {
        id: discountItems.length + 1,
        icon: "Icon",
        title: newDiscount.name,
        price: newDiscount.amount,
        selected: false,
      };
      setDiscountItems([...discountItems, newItem]);
      setNewDiscount({ name: "", amount: "0원" });
    }

    setShowPopup(false);
  };

  const handleInputChangeDiscount = (e) => {
    const { name, value } = e.target;
    setNewDiscount({
      ...newDiscount,
      [name]: value,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleOperationTimeChange = (type) => {
    setOperationTimes({
      ...operationTimes,
      [type]: !operationTimes[type],
    });
  };

  const handleTimeRangeChange = (e) => {
    const { name, value } = e.target;
    setTimeRanges({
      ...timeRanges,
      [name]: value,
    });
  };

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleAddOrUpdateParking = async () => {
    const currentDate = getCurrentDate();

    // If this is a new creation, both creation date and edit date are the same
    // If this is an edit, only update the edit date
    const creationDate = isEdit ? formData.creationDate : currentDate;
    const editDate = currentDate;

    const payload = {
      ...formData,
      creationDate,
      editDate,
      timeRanges: { ...timeRanges },
      discountList: discountItems.map((item) => ({
        name: item.title,
        amount: item.price,
      })),
    };

    try {
      if (isEdit) {
        await updateParking(payload);
      } else {
        await createParking(payload);
      }

      // Navigate to parking_setting_manager with the required data
      navigate("/parking_setting_list", {
        state: {
          parkingName: formData.parkingName,
          parkingId: formData.parkingId,
          creationDate: creationDate,
          editDate: editDate,
        },
      });
    } catch (error) {
      console.error("Error:", error);
      // alert("저장이 실패했습니다. 다시 시도해주세요.");
    }
  };
  const handleCancel = () => {
    navigate("/parking_setting_list");
  };
  return (
    <div className="parking-status-container">
      <div className="form-container">
        <div className="form-group">
          <label>관리번호</label>
          <input
            type="text"
            name="parkingId"
            value={formData.parkingId}
            onChange={handleInputChange}
            placeholder="관리번호를 입력해주세요."
          />
        </div>

        <div className="form-group">
          <label>주차장명</label>
          <input
            type="text"
            name="parkingName"
            value={formData.parkingName}
            onChange={handleInputChange}
            placeholder="주차장명을 입력해주세요."
          />
        </div>

        <div className="form-group">
          <label>주차면수</label>
          <input
            type="text"
            name="parkingSpaces"
            value={formData.parkingSpaces}
            onChange={handleInputChange}
            placeholder="주차면수를 입력해주세요."
          />
        </div>

        <div className="form-group">
          <label>급지구분</label>
          <div className="select-wrapper">
            <select
              name="classCd"
              value={formData.classCd}
              onChange={handleInputChange}
            >
              <option value="010">1급지</option>
              <option value="020">2급지</option>
              <option value="030">3급지</option>
              <option value="040">4급지</option>
              <option value="050">5급지</option>
            </select>
          </div>
        </div>

        <div className="form-group">
          <label>주소</label>
          <div className="address-input">
            <input className="mn-input" type="text" readOnly placeholder="주소를 입력해주세요" style={{ flex: 1 }} />
            <button className="search-button" style={{height: "33px"}}>검색</button>
          </div>
        </div>

        <div className="form-group operation-time">
          <label>운영시간</label>
          <div className="time-options" style={{paddingBottom: '12px'}}>
            <label className="checkbox-label">
              <span>운영일원</span>
            </label>
            <div className="nl-row time-options-row" >
              <label className="checkbox-label">
                {/* <input
                  type="checkbox"
                  checked={operationTimes.halfDay}
                  onChange={() => handleOperationTimeChange("halfDay")}
                /> */}
                <AppCheckBox className={"mb-0 mr-5"} nameInput={"weekdayYn"}></AppCheckBox>
                <span>평일</span>
              </label>
              <label className="checkbox-label ml-15">
                {/* <input
                  type="checkbox"
                  checked={operationTimes.standby}
                  onChange={() => handleOperationTimeChange("standby")}
                /> */}
                <AppCheckBox className={"mb-0 mr-5"} nameInput={"weekendYn"}></AppCheckBox>
                <span>토요일</span>
              </label>
              <label className="checkbox-label ml-15">
                {/* <input
                  type="checkbox"
                  checked={operationTimes.publicHoliday}
                  onChange={() => handleOperationTimeChange("publicHoliday")}
                /> */}
                <AppCheckBox className={"mb-0 mr-5"} nameInput={"holidayYn"}></AppCheckBox>
                <span>공휴일</span>
              </label>
            </div>

          </div>

          <div className="time-ranges">
            <div className="time-range">
              <span>일반운영시간</span>
              <div className="time-inputs">
                <div className="time-start">
                  <span>시작시간</span>
                  <input
                    type="text"
                    name="regularStart"
                    value={timeRanges.regularStart}
                    onChange={handleTimeRangeChange}
                  />
                </div>
                <div className="time-end">
                  <span>종료시간</span>
                  <input
                    type="text"
                    name="regularEnd"
                    value={timeRanges.regularEnd}
                    onChange={handleTimeRangeChange}
                  />
                </div>
              </div>
            </div>

            <div className="time-range">
              <span>토요일운영시간</span>
              <div className="time-inputs">
                <div className="time-start">
                  <span>시작시간</span>
                  <input
                    type="text"
                    name="halfDayStart"
                    value={timeRanges.halfDayStart}
                    onChange={handleTimeRangeChange}
                  />
                </div>
                <div className="time-end">
                  <span>종료시간</span>
                  <input
                    type="text"
                    name="halfDayEnd"
                    value={timeRanges.halfDayEnd}
                    onChange={handleTimeRangeChange}
                  />
                </div>
              </div>
            </div>

            <div className="time-range">
              <span>공휴일운영시간</span>
              <div className="time-inputs">
                <div className="time-start">
                  <span>시작시간</span>
                  <input
                    type="text"
                    name="publicHolidayStart"
                    value={timeRanges.publicHolidayStart}
                    onChange={handleTimeRangeChange}
                  />
                </div>
                <div className="time-end">
                  <span>종료시간</span>
                  <input
                    type="text"
                    name="publicHolidayEnd"
                    value={timeRanges.publicHolidayEnd}
                    onChange={handleTimeRangeChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="form-group">
          <label>담당자</label>
          <input type="text" name="administrator" placeholder="담당자를 입력해주세요" />
        </div>

        <div className="form-group">
          <label>할인정보 등록</label>
          <div className="fee-options">
            {discountItems.map((fee) => (
              <div key={fee.id} className="fee-option">
                <div>
                  <img src={discountIcon} alt="discountIcon" />
                </div>
                <div>{fee.title}/{fee.price}</div>
              </div>
            ))}
            <button className="add-fee-button" onClick={handleOpenPopup}>
              <span>
                <img src={plusIcon} alt="plusIcon" />
              </span>
            </button>
          </div>
        </div>
      </div>

      {showPopup && (
        <div className="popup-overlay-form">
          <div className="popup">
            <div className="line-header"></div>
            <div className="input-section">
              <div className="input-title">할인정보 명칭</div>
              <div className="input-name">
                <input
                  type="text"
                  name="name"
                  value={newDiscount.name}
                  onChange={handleInputChangeDiscount}
                  placeholder="할인정보 명칭을 입력해주세요"
                />
              </div>
            </div>
            <div className="input-section">
              <div className="input-title pt-3">할인금액</div>
              <div className="amount">
                <input
                  type="text"
                  name="amount"
                  value={newDiscount.amount}
                  onChange={handleInputChangeDiscount}
                  placeholder="0 원"
                />
              </div>
            </div>

            <div className=" action-buttons pt-30">
              <button className=" delete-button" onClick={handleClosePopup}>
                닫기
              </button>
              <button className=" add-button" onClick={handleApply}>
                적용
              </button>
            </div>
          </div>
        </div>
      )}

      <ButtonBot
        textYes={`${isEdit ? "수정하기" : "저장하기"}`}
        textNo="취소하기"
        handleNo={handleCancel}
        handleYes={handleAddOrUpdateParking}
      />
    </div>
  );
};

export default ParkingFormAdd;
